module.exports = __webpack_public_path__ + "img/bg-2.f0bb57ea.png";